module.exports = __webpack_public_path__ + "7fdeb4b60e4def05a0673545c5a5dd24.svg";